export default __webpack_public_path__ + "static/media/create.2c9217a2.svg";